export enum LicensesEvent {
    ClickedStartTrial = 'Licenses.ClickedStartTrial',
    ClickedStartTrialClickedStartTrial = 'Licenses.ClickedStartTrialClickedStartTrial',
    ClickedStartTrialClickedStartTrialError = 'Licenses.ClickedStartTrialClickedStartTrialError',
    StartBasicTrialButtonClick = 'StartBasicTrialButton.Click',
    StartStandardTrialButtonClick = 'StartStandardTrialButton.Click',
}
